export default (address, formattedAddress) => ({
  city: address.city,
  country: address.countryCode,
  email: formattedAddress.email,
  family_name: formattedAddress.family_name,
  given_name: formattedAddress.given_name,
  phone: address.contactNumber,
  postal_code: address.postcode,
  region: address.region,
  street_address: address.line_1 !== '' ? `${address.line_1}, ${address.streetName}` : address.streetName,
  street_address2: address.line_2,
});
